import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ReactLoading from "react-loading";
import config from "../../config";

const Channel_integrate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const channel_id = searchParams.get("id");

  const [state, setState] = useState({
    name: "",
    url: "",
    key: "",
    password: "",
    store_id: "",
    webhook_url: "",
  });

  const [tempstate, setTempState] = useState({
    name: "",
    url: "",
    key: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const [connectionStatus, setConnectionStatus] = useState("idle");

  const [showSecret, setShowSecret] = useState(false);

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
  });

  /*
   * =========================================================
   * FIELD CHANGE
   * =========================================================
   */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /*
   * =========================================================
   * GET WOOCOMMERCE GENERATED KEYS
   * =========================================================
   */

  const getwoocommercegeneratedkeys = async () => {
    try {
      let uid = "";

      const currentUrl = window.location.href;

      const urluser = new URL(currentUrl);

      const userId = urluser.searchParams.get("user_id");

      if (userId) {
        uid = userId;
      }

      const response = await axios.post(
        `${config.apiUrl}/user/get_woocommerce_keys`,
        {
          channel_id,
          user_id: uid,
        },
        {
          headers: config.headers,
        }
      );

      if (response.data?.status === true) {
        const output = response.data.output || {};

        setState((prev) => ({
          ...prev,
          url: output.store_url || "",
          key: output.store_api_key || "",
          password: output.store_password || "",
        }));

        setTempState({
          url: output.store_url || "",
          key: output.store_api_key || "",
          password: output.store_password || "",
        });
      }
    } catch (error) {
      console.error("get_woocommerce_keys error =>", error);
    }
  };

  /*
   * =========================================================
   * LOAD KEYS
   * =========================================================
   */

  useEffect(() => {
    if (String(channel_id) !== "1507808901") {
      return;
    }

    getwoocommercegeneratedkeys();
  }, [channel_id]);

  /*
   * =========================================================
   * SAVE WOOCOMMERCE
   * =========================================================
   */

  const saveWoocommerce = async () => {
    if (!state.url?.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Store URL required",
        text: "Please enter your WooCommerce store URL.",
      });

      return;
    }

    if (!state.key?.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Consumer Key required",
        text: "Please enter the WooCommerce Consumer Key.",
      });

      return;
    }

    if (!state.password?.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Consumer Secret required",
        text: "Please enter the WooCommerce Consumer Secret.",
      });

      return;
    }

    try {
      setIsLoading(true);
      setConnectionStatus("testing");

      const response = await axios.post(
        `${config.apiUrl}/shipment/save_wooCoommerce_orders`,
        {
          channel_id,
          store_url: state.url.trim(),
          store_api_key: state.key.trim(),
          store_password: state.password.trim(),
        },
        {
          headers: config.headers,
        }
      );

      if (response.data?.status === true) {
        setConnectionStatus("success");

        await Toast.fire({
          icon: "success",
          title: "WooCommerce connected successfully",
        });

        navigate("/channel_list");
      } else {
        setConnectionStatus("error");

        Toast.fire({
          icon: "error",
          title: response.data?.message || "Unable to connect WooCommerce.",
        });
      }
    } catch (error) {
      console.error("save_wooCoommerce_orders error =>", error);

      setConnectionStatus("error");

      Toast.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Something went wrong while connecting WooCommerce.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  /*
   * =========================================================
   * OPTIONAL OLD GENERATE-KEY FLOW
   * =========================================================
   *
   * Keeping this because it already exists in your page.
   * The current UI doesn't require clicking it because the
   * existing generated credentials are loaded automatically.
   */

  const testWoocommerce = async () => {
    try {
      setIsLoading(true);

      const randomUserId = Math.floor(10000 + Math.random() * 90000);

      const newUrl = `${window.location.href}${
        window.location.href.includes("?") ? "&" : "?"
      }user_id=KalpCargo_${randomUserId}`;

      window.history.replaceState({}, document.title, newUrl);

      const response = await axios.post(
        `${config.apiUrl}/user/generate_woocommerce_keys`,
        {
          channel_id,
          store_url: state.url,
          redirectUrl: `${window.location.origin}/channel_integrate?id=${channel_id}`,
          user_id: `KalpCargo_${randomUserId}`,
        },
        {
          headers: config.headers,
        }
      );

      if (response.data?.status === true) {
        window.location.href = response.data.url;
      } else {
        Toast.fire({
          icon: "error",
          title: response.data?.message || "Unable to connect WooCommerce.",
        });
      }
    } catch (error) {
      console.error("generate_woocommerce_keys error =>", error);

      Toast.fire({
        icon: "error",
        title: "Something went wrong.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  /*
   * =========================================================
   * COPY
   * =========================================================
   */

  const handleCopy = async (value, label) => {
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);

      Toast.fire({
        icon: "success",
        title: `${label} copied`,
      });
    } catch (error) {
      console.error("copy error:", error);
    }
  };

  /*
   * =========================================================
   * ONLY WOOCOMMERCE FOR THIS PAGE
   * =========================================================
   */

  const isWooCommerce = String(channel_id) === "1507808901";

  if (!isWooCommerce) {
    return (
      <div>
        <Header>
          <div className="content">
            <div className="ci-empty">
              <div className="ci-empty-icon">
                <i className="bi bi-plug"></i>
              </div>

              <h2>Integration not found</h2>

              <p>This integration is not available on this page.</p>

              <button
                type="button"
                className="ol-btn primary"
                onClick={() => navigate("/channel_list")}
              >
                <i className="bi bi-arrow-left"></i>
                Back to integrations
              </button>
            </div>
          </div>
        </Header>

        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Header>
        <div className="content">
          {/* =================================================
              PAGE HEADER
              ================================================= */}

          <div className="ol-header ci-top">
            <div className="ol-hd">
              <button
                type="button"
                className="ol-back"
                title="Go back"
                onClick={() => navigate(-1)}
              >
                <i className="bi bi-arrow-left"></i>
              </button>
            </div>

            <div className="ol-actions">
              <button
                type="button"
                className="ol-btn ghost"
                onClick={() => navigate("/channel_list")}
              >
                <i className="bi bi-plug"></i>
                Integrations
              </button>

              <a href="/developer_apis" className="ol-btn">
                <i className="bi bi-book"></i>
                API Docs
              </a>
            </div>
          </div>

          {/* =================================================
              HERO
              ================================================= */}

          <div className="ci-hero">
            <div className="ci-hero-main">
              <div className="ci-brand">
                <div className="ci-logo">
                  <img
                    src="https://cdn.kalpcargo.com/channel_images/wooCommerce.png"
                    alt="WooCommerce"
                  />
                </div>

                <div>
                  <span className="ci-eyebrow">E-commerce Integration</span>

                  <h1>Integrate WooCommerce</h1>
                </div>
              </div>

              <p className="ci-hero-desc">
                Connect your WooCommerce store to KalpCargo and manage orders
                and shipments directly from your shipping dashboard.
              </p>

              <div className="ci-trust-row">
                <span>
                  <i className="bi bi-shield-check"></i>
                  Secure credentials
                </span>

                <span>
                  <i className="bi bi-arrow-repeat"></i>
                  Order synchronization
                </span>

                <span>
                  <i className="bi bi-box-seam"></i>
                  Shipment management
                </span>
              </div>
            </div>

            <div className="ci-status-card">
              <div
                className={`ci-status-icon ${
                  connectionStatus === "success" ? "success" : ""
                }`}
              >
                <i
                  className={`bi ${
                    connectionStatus === "success"
                      ? "bi-check2-circle"
                      : "bi-plug"
                  }`}
                ></i>
              </div>

              <div>
                <b>
                  {connectionStatus === "testing"
                    ? "Connecting..."
                    : connectionStatus === "success"
                    ? "Connected"
                    : "Ready to connect"}
                </b>

                <small>
                  {connectionStatus === "testing"
                    ? "Testing your store credentials"
                    : "One-time setup"}
                </small>
              </div>
            </div>
          </div>

          {/* =================================================
              NOTICE
              ================================================= */}

          <div className="ci-notice">
            <div className="ci-notice-icon">
              <i className="bi bi-info-circle"></i>
            </div>

            <div>
              <b>Before you begin</b>

              <p>
                Please create a pickup point / warehouse from the
                <strong> Warehouse</strong> section in the left menu before
                connecting your WooCommerce store.
              </p>
            </div>
          </div>

          {/* =================================================
              MAIN LAYOUT
              ================================================= */}

          <div className="ci-layout">
            {/* =================================================
                LEFT — INSTRUCTIONS
                ================================================= */}

            <div className="ci-main">
              <section className="ci-card card-base">
                <div className="ci-card-header">
                  <div className="ci-step-number">1</div>

                  <div>
                    <h2>Prepare your WooCommerce store</h2>

                    <p>Follow these steps in your WordPress admin panel.</p>
                  </div>
                </div>

                <div className="ci-card-body">
                  <ol className="ci-steps">
                    <li>
                      Login to your
                      <strong>WordPress Admin</strong> panel.
                    </li>

                    <li>
                      Navigate to <strong>Plugins</strong> and click{" "}
                      <strong>Add New</strong>.
                    </li>

                    <li>
                      Search for <strong>WooCommerce</strong> and install the
                      plugin if it is not already installed.
                    </li>

                    <li>
                      Once installed, click <strong>Activate</strong>.
                    </li>

                    <li>
                      Go to <strong>WooCommerce</strong> →{" "}
                      <strong>Settings</strong>.
                    </li>

                    <li>
                      Open the <strong>Advanced</strong> tab and select{" "}
                      <strong>REST API</strong>.
                    </li>

                    <li>
                      Click <strong>Add Key</strong>.
                    </li>

                    <li>
                      Give the API key a recognizable name, such as{" "}
                      <strong>KalpCargo</strong>.
                    </li>

                    <li>
                      Set permission to <strong>Read/Write</strong>.
                    </li>

                    <li>
                      Click <strong>Generate API Key</strong>.
                    </li>

                    <li>
                      WooCommerce will show your <strong>Consumer Key</strong>{" "}
                      and <strong>Consumer Secret</strong>.
                    </li>

                    <li>
                      Enter those credentials on the right side of this page.
                    </li>
                  </ol>
                </div>
              </section>

              {/* =================================================
                  SECURITY INFORMATION
                  ================================================= */}

              <section className="ci-security card-base">
                <div className="ci-security-icon">
                  <i className="bi bi-shield-check"></i>
                </div>

                <div>
                  <h3>Keep your credentials secure</h3>

                  <p>
                    Your WooCommerce Consumer Key and Consumer Secret provide
                    access to your store API. Do not share them publicly.
                  </p>
                </div>
              </section>
            </div>

            {/* =================================================
                RIGHT — CONNECTION FORM
                ================================================= */}

            <aside className="ci-sidebar">
              <div className="ci-form-card card-base">
                <div className="ci-form-header">
                  <div className="ci-form-icon">
                    <i className="bi bi-shop"></i>
                  </div>

                  <div>
                    <h2>Store settings</h2>

                    <p>Enter your WooCommerce credentials.</p>
                  </div>
                </div>

                <div className="ci-form-body">
                  {/* STORE URL */}

                  <div className="ci-field">
                    <label>
                      Store URL
                      <span>*</span>
                    </label>

                    <div className="ci-input-wrap">
                      <i className="bi bi-globe2"></i>

                      <input
                        type="text"
                        name="url"
                        value={state.url}
                        onChange={handleChange}
                        placeholder="https://yourstorename.com"
                        autoComplete="off"
                      />

                      {state.url && (
                        <button
                          type="button"
                          onClick={() => handleCopy(state.url, "Store URL")}
                          title="Copy URL"
                        >
                          <i className="bi bi-copy"></i>
                        </button>
                      )}
                    </div>

                    <small>Example: https://yourstorename.com</small>
                  </div>

                  {/* CONSUMER KEY */}

                  <div className="ci-field">
                    <label>
                      Consumer Key
                      <span>*</span>
                    </label>

                    <div className="ci-input-wrap">
                      <i className="bi bi-key"></i>

                      <input
                        type="text"
                        name="key"
                        value={state.key}
                        onChange={handleChange}
                        placeholder="ck_..."
                        autoComplete="off"
                      />

                      {state.key && (
                        <button
                          type="button"
                          onClick={() => handleCopy(state.key, "Consumer Key")}
                          title="Copy key"
                        >
                          <i className="bi bi-copy"></i>
                        </button>
                      )}
                    </div>
                  </div>

                  {/* CONSUMER SECRET */}

                  <div className="ci-field">
                    <label>
                      Consumer Secret
                      <span>*</span>
                    </label>

                    <div className="ci-input-wrap">
                      <i className="bi bi-shield-lock"></i>

                      <input
                        type={showSecret ? "text" : "password"}
                        name="password"
                        value={state.password}
                        onChange={handleChange}
                        placeholder="cs_..."
                        autoComplete="off"
                      />

                      <button
                        type="button"
                        onClick={() => setShowSecret((prev) => !prev)}
                        title={showSecret ? "Hide secret" : "Show secret"}
                      >
                        <i
                          className={`bi ${
                            showSecret ? "bi-eye-slash" : "bi-eye"
                          }`}
                        ></i>
                      </button>
                    </div>
                  </div>

                  {/* CREDENTIAL STATUS */}

                  {tempstate.key && (
                    <div className="ci-generated">
                      <i className="bi bi-check-circle-fill"></i>

                      <div>
                        <b>WooCommerce credentials loaded</b>

                        <span>
                          Existing credentials were found. Review them before
                          testing.
                        </span>
                      </div>
                    </div>
                  )}

                  {/* ACTION */}

                  <button
                    type="button"
                    className="ci-connect-btn"
                    disabled={isLoading}
                    onClick={saveWoocommerce}
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm"></span>
                        Testing connection...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-plug"></i>
                        Test WooCommerce
                        <i className="bi bi-arrow-right"></i>
                      </>
                    )}
                  </button>

                  <div className="ci-form-note">
                    <i className="bi bi-lock-fill"></i>

                    <span>
                      Your credentials are sent securely to KalpCargo for
                      connection validation.
                    </span>
                  </div>
                </div>
              </div>

              {/* QUICK HELP */}

              <div className="ci-help-card card-base">
                <div className="ci-help-title">
                  <i className="bi bi-question-circle"></i>
                  Need help?
                </div>

                <p>
                  Make sure your store URL includes <strong>https://</strong>{" "}
                  and your WooCommerce API key has <strong>Read/Write</strong>{" "}
                  permissions.
                </p>

                {/* <a href="/developer_apis" className="ci-help-link">
                  View API documentation
                  <i className="bi bi-arrow-right"></i>
                </a> */}
              </div>
            </aside>
          </div>
        </div>
      </Header>

      <Footer />
    </div>
  );
};

export default Channel_integrate;
